// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"21f93297","274":"74d3ba1d","448":"a8706fd4","509":"df56c33d","786":"74d3ba1d","836":"0907f376"}[chunkId] + ".chunk.css";
};